var exports = {
  "kL": "xf0b3b88a--93cc3b--container",
  "k1": "xf0b3b88a--93cc3b--building-link",
  "Bh": "xf0b3b88a--93cc3b--external-reliable-icon",
};

module.exports = exports;
